export default __webpack_public_path__ + "static/training-catalog-fr-02fb551e39bceb6e7ff7dd04c7cad0ce.webp";